{#if isExternal}
    <EmptyHeader />
{/if}

<script>
    import EmptyHeader from '@itslearning/prometheus/assets/nodes/EmptyHeader/v1/EmptyHeader.svelte';

    /** @type {boolean} */
    export let isExternal;
</script>
